// extracted by mini-css-extract-plugin
export default {"whyMsigmaCarouselCard":"NewsAndMedia_whyMsigmaCarouselCard__4PEO0","SwiperImage":"NewsAndMedia_SwiperImage__dpq9J","DotctorsTalk":"NewsAndMedia_DotctorsTalk__NthNr"};